export const promiseAllSettled = (
  ...promises: Array<() => Promise<unknown>>
) => {
  const tasks = promises.map((p) =>
    p()
      .then((v) => {
        return {
          status: 'fulfilled',
          value: v,
        };
      })
      .catch((e) => {
        return {
          status: 'rejected',
          value: e,
        };
      })
  );

  return Promise.all(tasks)
    .then((results) => {
      const rejects = results.filter((s) => s.status === 'rejected');
      if (rejects.length) {
        throw rejects.map((s) => s.value as unknown);
      } else {
        return results.map((s) => s.value as unknown);
      }
    })
    .catch((err) => {
      throw err;
    });
};
